import React, { useState, useEffect, useRef } from "react";
import {MegamenuFeaturedImages} from "../../MegamenuFeaturedImages/MegamenuFeaturedImages";
import {MegamenuLinks} from "../../MegamenuLinks/MegamenuLinks";
import {MegamenuFeaturedContent} from "../../MegamenuFeaturedContent/MegamenuFeaturedContent";
import useMegamenu from "../../hooks/useMegamenu";
import {MegamenuOverlay} from "../../MegamenuOverlay/MegamenuOverlay";

export const Default = ({
    settings,
    menuItems,
    id,
    layout,
    state
}) => {
    const megamenuRef = React.useRef(null); // Reference to the popup container
    const megamenuSM = useMegamenu(megamenuRef, menuItems, false);
    const [headerMenuPosition, setHeaderMenuPosition] = useState(null);
    
    // Apply main megamenu styling
    const megamenuStyle = {
        maxWidth: settings.section.megamenu_width ? `${settings.section.megamenu_width}px` : '100%',
        height: settings.section.megamenu_height ? `${settings.section.megamenu_height}px` : '100vh',
    };
    
    // Calculate featured content width
    const featuredWidth = settings.section.featured_column_width > 0
        ? `${settings.section.featured_column_width}px`
        : '30%'; // Default to 30% if not specified
    
    // Set up column gaps
    const columnGaps = {
        columnGap: settings.section.column_gap_x ? `${settings.section.column_gap_x}px` : '16px',
        rowGap: settings.section.column_gap_y ? `${settings.section.column_gap_y}px` : '16px',
    };
    
    // Set up featured column gaps
    const featuredColumnGaps = {
        columnGap: settings.section.featured_column_gap_x ? `${settings.section.featured_column_gap_x}px` : '16px',
        rowGap: settings.section.featured_column_gap_y ? `${settings.section.featured_column_gap_y}px` : '16px',
    };

    // Determine whether to show featured content or images
    const showFeaturedContent = settings.section.show_featured_content && 
                               (megamenuSM.featuredArticles?.length > 0 || 
                                settings.section.show_featured_articles);
    
    const showFeaturedImages = megamenuSM.featuredImageBlocks.length > 0;

    useEffect(() => {
        const matchingHeaderMenu = document.querySelector(`.header-menu li[data-id="${id}"]`);
        if (matchingHeaderMenu) {
            const rect = matchingHeaderMenu.getBoundingClientRect();
            setHeaderMenuPosition(`${(rect.left + window.scrollX) - settings.section.padding_left_right_desktop - 16}px`);
        }

        const handleMobileMenuClosed = () => megamenuSM.handleMenuClose();
        window.addEventListener("mobile-menu-closed", handleMobileMenuClosed);

        return () => {
            window.removeEventListener("mobile-menu-closed", handleMobileMenuClosed);
        };
    }, [state, id]);

    const overlayBlock = settings.blocks.find(block => block.type === 'overlay');

    return (
        <>
            {overlayBlock && <MegamenuOverlay settings={overlayBlock} type={'darken'}/>}
            <nav 
                className={`
                    default
                    megamenu-nav
                    megamenu-${layout}
                    ${settings.section.container_type}
                    ${megamenuSM.getPadding(settings.section)}
                `} 
                ref={megamenuRef}
                style={megamenuStyle}
            >
                <div className={`relative`}>
                    <div 
                        className={`megamenu-nav-area flex items-${settings.section.content_alignment_desktop || 'start'}`}
                        style={columnGaps}
                    >
                        {/* Main links container */}
                        <div 
                            className={`megamenu-nav-list w-full flex flex-col ${settings.section.column_spacing}`}
                            style={{
                                flexBasis: showFeaturedContent || showFeaturedImages ? '70%' : '100%',
                                ...columnGaps,
                                paddingLeft: headerMenuPosition,
                            }}
                        >
                            <MegamenuLinks settings={settings} megamenuSM={megamenuSM} />
                        </div>
                        
                        {/* Featured content container */}
                        {(showFeaturedContent || showFeaturedImages) && (
                            <div 
                                className="megamenu-featured-container flex flex-col"
                                style={{ 
                                    flexBasis: featuredWidth,
                                    ...featuredColumnGaps
                                }}
                            >
                                {/* Show images if available, otherwise show articles */}
                                {showFeaturedImages ? (
                                    <MegamenuFeaturedImages settings={settings} megamenuSM={megamenuSM} />
                                ) : showFeaturedContent && (
                                    <MegamenuFeaturedContent settings={settings} megamenuSM={megamenuSM} />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Default;
